import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const PageContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: #ffffff;

  > div {
    height: 100% !important;
  }
`;

export const DivisionChangeName = styled.div`
  max-width: 520px;
  overflow: auto;

  h3 {
    font-size: 1.1rem;
    color: #808080;
  }

  label {
    font-size: 0.8rem;
    color: #808080;
    margin-bottom: 0.2rem;
  }

  input {
    box-shadow: 0px 2px 4px #00000066;
    border-radius: 0.4rem;
    border: 0;
    padding: 0.2rem;
  }

  @media (max-height: 622px) {
    height: 100vh;
  }

  @media (min-width: 550px) {
    margin: 1rem 3rem;
  }

  @media (min-width: 771px) {
    max-width: 800px;
  }
`;

export const DivisionButton = styled.div`
  width: 120px;
  align-self: center;

  button {
    margin-top: 1rem;
  }
`;

export const BackIcon = styled(Link)`
  display: flex;
  justify-content: flex-end;
  margin: 1rem 1rem 0 0;
`;

export const DivisionMobile = styled.div`
  @media (min-width: 768px) {
    display: none;
  }

  @media (max-width: 768px) {
    display: block;
  }
`;

export const Content = styled.div`
  padding: 0.5rem 2rem 2rem 2rem;
  display: flex;
  flex-direction: column;
  height: 80vh;

  form {
    display: flex;
    flex-direction: column;
    max-width: 500px;
  }

  @media (max-width: 770px) {
    height: 85vh;
    form {
      max-width: 400px;
    }
  }
  @media (max-width: 390px) {
    padding: 0.5rem;
  }

  @media (max-height: 674px) {
    height: 105vh;
  }

  @media (max-height: 615px) {
    height: 115vh;
  }
`;

export const IconLoading = styled.i`
  font-size: 1.5rem;
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0 0 20px 20px;
  background-color: white;

  @media (max-width: 770px) {
    padding: 0;
  }
`;
